"use client";

import * as React from "react";

import * as LabelPrimitive from "@radix-ui/react-label";


function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={`flex items-center gap-2 select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 ${className || ''}`}
      {...props}
    />
  );
}

export { Label };
